import React from 'react';
import { View } from 'react-native';
import Button from '../../../components/Button/Button';
import { styles } from '../screens/Policy/PolicyScreen.styles';

interface NavigationButtonsProps {
  onBack: () => void;
  onNext: () => void;
  isNextDisabled: boolean;
  backTitle?: string;
  nextTitle?: string;
  testID?: string;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onBack,
  onNext,
  isNextDisabled,
  backTitle = 'Back', // Default to "Back"
  nextTitle = 'Next', // Default to "Next",
  testID,
}) => {
  return (
    <View style={styles.footerButtonsContainer}>
      <Button
        title={backTitle}
        type="tertiary"
        testID={`${testID}-back`}
        onPress={onBack}
        style={styles.footerButtonLeft}
      />
      <Button
        testID={`${testID}-next`}
        title={nextTitle}
        type={'primary'}
        colorVariant={isNextDisabled ? 'disabled' : 'default'}
        onPress={onNext}
        disabled={isNextDisabled}
        style={styles.footerButtonRight}
      />
    </View>
  );
};

export default NavigationButtons;
